var _a;
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    bypassChooser: false,
    isVoted: {},
    declinedToVote: {},
    completedAcclaimedElections: {},
};
export var extraSlice = createSlice({
    name: "extra",
    initialState: initialState,
    reducers: {
        setBypassChooser: function (state, action) {
            state.bypassChooser = action.payload;
            return state;
        },
        setIsVoted: function (state, action) {
            state.isVoted[action.payload] = true;
            return state;
        },
        setDeclinedToVote: function (state, action) {
            state.declinedToVote[action.payload] = true;
            return state;
        },
        clearDeclinedToVoteForElection: function (state, action) {
            delete state.declinedToVote[action.payload];
            return state;
        },
        completeAcclaimedElection: function (state, action) {
            state.completedAcclaimedElections[action.payload] = true;
            return state;
        },
        clearIsVoted: function (state) {
            state.isVoted = {};
            state.declinedToVote = {};
            return state;
        },
    },
});
export var setBypassChooser = (_a = extraSlice.actions, _a.setBypassChooser), setIsVoted = _a.setIsVoted, setDeclinedToVote = _a.setDeclinedToVote, clearDeclinedToVoteForElection = _a.clearDeclinedToVoteForElection, completeAcclaimedElection = _a.completeAcclaimedElection, clearIsVoted = _a.clearIsVoted;
export var selectBypassChooser = function () { return function (state) { return state.extra.bypassChooser; }; };
export var isVotedByElectionId = function (electionId) { return function (state) {
    return electionId ? state.extra.isVoted[electionId] : false;
}; };
export var isDeclineToVoteByElectionId = function (electionId) { return function (state) {
    return electionId ? Boolean(state.extra.declinedToVote[electionId]) : false;
}; };
export var isAcclaimedElectionCompleted = function (electionId) { return function (state) { var _a; return electionId ? Boolean((_a = state.extra.completedAcclaimedElections) === null || _a === void 0 ? void 0 : _a[electionId]) : false; }; };
export default extraSlice.reducer;
